$(function(){

  const $form = $('.m-contact-form__form-fields').closest('form');
  const $btn = $form.find('button[type="submit"]');

  $btn.prop('disabled', true);

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function checkFields() {
    let valid = true;

    $form.find('input[required], textarea[required]').each(function(){
      if (!$(this).val().trim()) {
        valid = false;
      }
    });

    $form.find('input[name="contact[email]"]').removeClass("error");

    const emailVal = $form.find('input[name="contact[email]"]').val().trim();
    if (!isValidEmail(emailVal)) {
      valid = false;
      $form.find('input[name="contact[email]"]').val("");
      $form.find('input[name="contact[email]"]').addClass("error");
    }

    $btn.prop('disabled', !valid);
  } 

  $form.on('change', function(){
    checkFields();
  });

});